export default "__VITE_ASSET__fcbe11cd__"